<template src="./ViewTask.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Pagination from "@/components/components/pagination";
import TopMenu from "@/components/competitors/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('competitors/viewTask');

export default {
  name: "CompetitorsTask",
  components: {
    Pagination,
    TopMenu,
  },
  data() {
    return {
      showOverlay: 0,
      taskId: this.$route.params.id,
      fieldsList: [
        {
          key: 'id',
          label: 'Номер записи',
        },
        {
          key: 'competitor',
          label: 'Сайт',
        },
        {
          key: 'price',
          label: 'Цена',
        },
        {
          key: 'currency',
          label: 'Валюта',
        },
        {
          key: 'euroPrice',
          label: 'Евро',
        },
        {
          key: 'isVAT',
          label: 'НДС',
        },
        {
          key: 'isAvailability',
          label: 'Наличие на складе',
        },
        {
          key: 'statuses',
          label: 'Обратная связь',
        },
      ]
    }
  },
  methods: {
    ...mapActions(['GET_INFO', 'SET_STATUS']),
    goToPage(page) {
      this.$store.commit('competitors/viewTask/CURRENT_PAGE', page)
      this.getData()
    },
    perPage(page) {
      this.$store.commit('competitors/viewTask/PER_PAGE', page)
      this.$store.commit('competitors/viewTask/CURRENT_PAGE', 1)
      this.getData()
    },
    selfInitPageSize() {
      let winHeight = this.initPageSize(305)
      this.$store.commit('competitors/viewTask/PER_PAGE', winHeight)
      this.$store.commit('competitors/viewTask/CURRENT_PAGE', 1)
    },
    setStatus(foundId, statusKey, statusVal) {
      this.SET_STATUS({th: this, foundId: foundId, statusKey: statusKey, statusVal: statusVal})
    },
    getData() {
      this.GET_INFO({th: this, id: this.taskId})
    },
    bFormat(val) {
      return val === true ? 'да' : val === false ? 'нет' : 'н/д'
    }

  },
  computed: {
    ...mapGetters([
      'TASKS_INFO',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
      'PRICE_STATUSES',
    ]),
  },
  mounted() {
    this.selfInitPageSize()
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('competitors') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>